<template>
<p>
This page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it.<br/>
Thank you.
</p>
</template>

<script>

export default {
  name: 'last',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 41_chapter38.vue?3d3967b7